module.exports = __webpack_public_path__ + "static/media/sprinkler.ba00197b.svg";